import defaultValues from './defaultValues'

const active = JSON.parse(defaultValues);

export default active;